import React from "react";
import { Box } from "@mui/material";
import { AnalyticsPageHeader } from "./components/Header/AnalyticsPageHeader";
import { TopPositions } from "./Sections/TopPositions/TopPositions";
import { OrderGraph } from "./Sections/OrderGraph/OrderGraph";
import { AnalyticsSales } from "./Sections/Sales/AnalyticsSales";

export const AnalyticsPage: React.FC = () => {
  return (
    <Box>
      <AnalyticsPageHeader />

      <TopPositions />
      <OrderGraph />
      <AnalyticsSales />
    </Box>
  );
};